module.exports = __webpack_public_path__ + "static/media/daily reports.ec80b930.svg";